module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/availability.svg?ec228c7d";